export default __webpack_public_path__ + "static/media/world.f19f3b6b.svg";